export default "__VITE_ASSET__RzqslpqE__"